export enum ChatFeedbackStatusEnum {
  AGUARDANDO_ANALISE = 1,
  ANALISE_CONCLUIDA = 2,
  CONCLUIDO = 3,
}

export const statusOption = [
  { label: "Aguardando Análise", value: 1 },
  { label: "Análise Concluída", value: 2 },
  { label: "Concluído", value: 3 },
];
